<template>
  <div id="theMainTableFixerInvestments" class="mt-2">
    <div
      class="tabulator registrar-table"
      ref="table"
      style="width: 100%; height: 100%"
    ></div>
  </div>
</template>
<script>
import Tabulator from "tabulator-tables";
import api from "../../axios_api";
import { mapGetters } from "vuex";
import moment from "moment";
import { json } from "d3";
import config from "../../../config/settings";
export default {
  components: {},
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    ...mapGetters("referrer", ["sentDeals"]),
    ...mapGetters("team", ["getAllUsers"]),
    ...mapGetters("role", ["checkRole"]),
    sentDealsData() {
      let self = this;
      let data = JSON.parse(JSON.stringify(this.sentDeals));
      data.map((dataItem, index) => {
        dataItem.totalCount =
          dataItem.invested + dataItem.referred + dataItem.rejected;
        dataItem.id = index;
        let temp =
          dataItem.companies && dataItem.companies.length
            ? dataItem.companies
            : [];
        if (temp.length > 0) {
          temp.sort((a, b) => {
            return new Date(a.created) - new Date(b.created);
          });
          temp = temp[temp.length - 1];
          dataItem.lastReferredOn = moment(temp.created).format("MM/DD/YYYY");
        } else dataItem.lastReferredOn = "-";
        dataItem.serviceHistory = [];
        dataItem.investCount = dataItem.invested ? dataItem.invested : 0;
        dataItem.rejectCount = dataItem.rejected ? dataItem.rejected : 0;
        dataItem.companies.map((companyItem) => {
          let user;
          if (companyItem.sent_by) {
            user = self.getAllUsers.find(
              (item) => item.account._id == companyItem.sent_by
            );
          }
          dataItem.serviceHistory.push({
            _id: companyItem._id ? companyItem._id : "",
            name: companyItem.name,
            logo: companyItem.logo,
            permalink: companyItem.permalink,
            created: companyItem.created
              ? moment(companyItem.created).format("MM/DD/YYYY")
              : "-",
            note: companyItem.note ? companyItem.note : "",
            color: companyItem.color,
            action: companyItem.action ? companyItem.action : "",
            sent_by: user
              ? `${user.account.firstName ? user.account.firstName : ""} ${
                  user.account.lastName ? user.account.lastName : ""
                }`
              : "-",
          });
        });
      });
      return {
        data: data,
        layout: "fitColumns",
        tooltips: true,
        tooltipsHeader: true,
        virtualDom: false,
        index: "_id",
        placeholder: "No records to view",
        rowFormatter: function (row) {
          //create and style holder elements
          var holderEl = document.createElement("div");
          holderEl.setAttribute("class", "childCollapseTable");
          var tableEl = document.createElement("div");
          const id = row.getData().id;
          tableEl.setAttribute("class", "company-second");
          tableEl.setAttribute("id", "subTable" + id + "");
          setTimeout(() => {
            tableEl.style.display = "none";
          });
          holderEl.appendChild(tableEl);

          row.getElement().appendChild(holderEl);
          var subTable = new Tabulator(tableEl, {
            layout: "fitColumns",
            virtualDOM: true,
            placeholder: "No records to view",
            data: row.getData().serviceHistory,
            columns: [
              {
                title: "",
                width: 50,
                resizable: false,
                field: "company",
                sorter: "string",
                headerSort: false,
                formatter: function (cell, formatterParams) {
                  let item = cell.getData();
                  item.logo = self.getImageUrl(item.logo);
                  item.logo = item.logo
                    ? item.logo
                    : "static/img/generic-logo.png";
                  return ` <div class="d-flex">
                    <img src="${item.logo}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/> `;
                },

                cellClick: function (e, cell) {
                  let permalink = cell.getData().permalink;
                  let company = self.portfolioAll.find(
                    (item) => item.permalink == permalink
                  );
                  if (company && company.ucid) {
                    self.$store.commit("temp/currentCompany", company.ucid);
                    self.$router.push(
                      `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${company.ucid}`
                    );
                  } else {
                    self.$router.push(
                      `/${self.$route.params.account_id}/shared/company?permalink=${permalink}&diligence=true&workspace_id=${self.$route.params.workspace_id}`
                    );
                  }
                },
              },
              {
                title: "Company",
                field: "name",
                sorter: "string",
                cellClick: function (e, cell) {
                  let permalink = cell.getData().permalink;
                  let company = self.portfolioAll.find(
                    (item) => item.permalink == permalink
                  );
                  if (company && company.ucid) {
                    self.$store.commit("temp/currentCompany", company.ucid);
                    self.$router.push(
                      `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${company.ucid}`
                    );
                  } else {
                    self.$router.push(
                      `/${self.$route.params.account_id}/shared/company?permalink=${permalink}&diligence=true&workspace_id=${self.$route.params.workspace_id}`
                    );
                  }
                },
              },
              { title: "Date", field: "created", sorter: "String" },
              {
                title: "Sent by",
                field: "sent_by",
                sorter: "String",
              },
              {
                title: "Action",
                field: "action",
                sorted: "string",
                formatter: function (cell, formatterParams) {
                  let data = cell.getData();
                  let color = data.color ? data.color : "";
                  if (data.action.toLowerCase() == "passed") color = "#FFA3AB";
                  else if (data.action.toLowerCase() == "referred")
                    color = "#F7B69E";
                  return data.action
                    ? `
                  <div style="height:25px;background-color:${color}" class="badge invest-badge px-3">${data.action}</div>`
                    : "-";
                },
                editable: self.checkRole == "Guest" ? false : true,
                editor: "select",
                editorParams: { values: ["Referred", "Passed", "Invested"] },
              },
              {
                title: "Notes",
                field: "note",
                sorter: "String",
                tooltip: true,
                editor: "input",
              },
            ],
            cellEdited: function (cell) {
              let data = cell.getRow().getData();
              let payload = {
                _id: data._id,
                note: data.note ? data.note : "",
                action: data.action ? data.action : "",
              };
              self.$store
                .dispatch("referrer/apiEditSentDeals", payload)
                .then((response) => {
                  let tableData = self.tabulator.getData();
                  tableData.map((rowItem) => {
                    let index = -1;
                    if (rowItem.serviceHistory) {
                      index = rowItem.serviceHistory.findIndex(
                        (item) => item._id == data._id
                      );
                    }
                    if (index >= 0) {
                      rowItem.serviceHistory[index].action = data.action;
                      rowItem.serviceHistory[index].note = data.note;
                      rowItem.totalCount = 0;
                      rowItem.rejectCount = 0;
                      rowItem.investCount = 0;
                      rowItem.serviceHistory.map((item) => {
                        if (item.action) {
                          console.log(item.name, item.action);
                          rowItem.totalCount++;
                          if (item.action.toLowerCase() == "passed")
                            rowItem.rejectCount++;
                          if (item.action.toLowerCase() == "invested")
                            rowItem.investCount++;
                        }
                      });
                      self.tabulator.updateData([rowItem]);
                    }
                  });
                })
                .catch((err) => {
                  console.log({ err });
                });
            },
          });
        },
        columns: [
          {
            title: "Name",
            field: "text",
            sorter: "string",
            resizable: true,
            //  width: "150",
            cellClick: function (e, row, formatterParams) {
              const id = row.getData().id;
              var table = document.getElementById("subTable" + id);
              table.style.display = table.style.display == "" ? "none" : "";
            },
            formatter: function (cell) {
              let data = cell.getData();
              return `<b style="text-transform: capitalize;">${data.text}</b>`;
            },
          },
          {
            title: "Referred Over Time",
            field: "totalCount",
            sorter: "number",
            //  width: "190",
            resizable: true,
            cellClick: function (e, row, formatterParams) {
              const id = row.getData().id;
              var table = document.getElementById("subTable" + id);
              table.style.display = table.style.display == "" ? "none" : "";
            },
          },
          {
            title: "Invested",
            field: "investCount",
            sorter: "number",
            // width: "100",
            //   hozAlign: "center",
            resizable: true,
            cellClick: function (e, row, formatterParams) {
              const id = row.getData().id;
              var table = document.getElementById("subTable" + id);
              table.style.display = table.style.display == "" ? "none" : "";
            },
          },
          {
            title: "Passed",
            field: "rejectCount",
            sorter: "number",
            //   width: "100",
            // hozAlign: "center",
            resizable: true,
            cellClick: function (e, row, formatterParams) {
              const id = row.getData().id;
              var table = document.getElementById("subTable" + id);
              table.style.display = table.style.display == "" ? "none" : "";
            },
          },
          {
            title: "Last Time Referred",
            field: "lastReferredOn",
            //  width: "200",
            sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
              return new Date(a) - new Date(b); //you must return the difference between the two values
            },
            resizable: true,
            cellClick: function (e, row, formatterParams) {
              const id = row.getData().id;
              var table = document.getElementById("subTable" + id);
              table.style.display = table.style.display == "" ? "none" : "";
            },
          },
        ],
      };
    },
  },
  data() {
    return {
      refreshCheck: 0,
      referrers: [],
      tabulator: null,
    };
  },
  watch: {},
  methods: {
    getTabulatorDetails(list) {
      this.tabulator = list;
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.table, this.sentDealsData);
  },
};
</script>
<style>
.refer-table .card-body {
  padding-left: 0px;
  padding-right: 0px;
}

.refer-table .tabulator-arrow {
  margin-top: 10px !important;
}
</style>